import { NgModule,
    Component }                 from '@angular/core';
import { NavController,
    IonicApp,
    IonicModule}                from 'ionic-angular';
import { ViewChild }            from    '@angular/core';
import { Platform }             from 'ionic-angular';
import {FaceBookService}        from '../../providers/facebook-provider';
import {FirebaseService}        from '../../providers/firebase-provider';

declare var window: any;

@Component({
    selector: 'login',  
    templateUrl: 'login.page.html'
})
export class loginComponent {
    login: { username?: string, password?: string } = {};
    constructor(
        private platform: Platform,
        private faceBookService: FaceBookService,
        private firebaseService: FirebaseService
    ) {        
    }
    emailLogin(obj: any) {
        this.firebaseService.login('email',"","");
    }
    facebookLogin(obj: any) {
        this.firebaseService.login('facebook');
    }
    googleLogin(obj: any) {
        this.firebaseService.login('google');
    }
    
}



// WEBPACK FOOTER //
// ./src/app/feature/loginModule/pages/login/login.page.ts